import { useMemo } from "react";

export default function usePieChart(data, subCategories) {
  return useMemo(() => {
    const labels = [];
    const values = [];

    for (const subCat of subCategories) {
      const items = data[subCat];

      // Skip non-array categories (Trusted Contacts, Inactivity Settings, etc.)
      if (!Array.isArray(items)) continue;

      const total = items.reduce(
        (sum, item) => sum + Number(item.amount || 0),
        0
      );

      if (total > 0) {
        labels.push(subCat);
        values.push(total);
      }
    }

    return {
      labels,
      values,
      pieData: {
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: [
              "#FF5F6D", "#00E5FF", "#FFD500", "#7C4DFF",
              "#00FF9C", "#FF3F8E", "#40C4FF", "#FF9100",
              "#B388FF", "#69F0AE"
            ],
            borderWidth: 0
          }
        ]
      }
    };
  }, [data, subCategories]);
}
